import { Icon, IconProps, useSlotRecipe } from '@chakra-ui/react'
import { convertIconSetToChakraSVG } from '../Icon/Icon.utils'
import { IconSize, IconSizes } from '../../theme/iconSize'
import { IconName } from '../Icon/Icon.types'

type SnackbarIconProps = IconProps & {
  iconName: IconName
  iconSize: IconSize
}

export const SnackbarIcon = (props: SnackbarIconProps) => {
  const { iconName, iconSize } = props
  const recipe = useSlotRecipe({ key: 'snackbar' })
  const styles = recipe()

  return (
    <Icon
      as={convertIconSetToChakraSVG(iconName)}
      boxSize={IconSizes[iconSize]}
      css={styles.icon}
    />
  )
}
